module.exports = __webpack_public_path__ + "img/icon-coffer-gold.dd3f4ba8.svg";